module.exports = __webpack_public_path__ + "static/img/deal_main_x.31823130.png";